import { createSlice } from '@reduxjs/toolkit';
import { extractHash } from '../utils/url';
import {
  changeLocation,
  setLoadingOverlay,
  overlayError,
  dismissAppAndOverlayError,
} from '../actions';
import type { ErrorActionPayload } from '../actions';
import { getOverlayName, isSidebarApp } from './utils';

export interface CurrentOverlayState {
  name: string | null;
  pathAndQuery: string;
  isLoading: boolean;
  isTemporarilyHidden: boolean;
  error: ErrorActionPayload | null;
}

const initialState: CurrentOverlayState = {
  name: null,
  pathAndQuery: '',
  isLoading: false,
  isTemporarilyHidden: false,
  error: null,
};

const currentOverlaySlice = createSlice({
  name: 'currentOverlay',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(changeLocation, (state, action) => {
        const hashUrl = extractHash(action.payload.url);
        const name = getOverlayName(hashUrl) ?? null;
        if (isSidebarApp(hashUrl)) {
          state.name = null;
          state.pathAndQuery = '';
          state.isTemporarilyHidden = false;
          return;
        }
        state.name = name;
        state.pathAndQuery = hashUrl.replace(/^#/, '');
        state.isTemporarilyHidden = name === 'search';
      })
      .addCase(setLoadingOverlay, (state, action) => {
        state.isLoading = action.payload;
      })
      .addCase(overlayError, (state, action) => {
        state.error = action.payload;
      })
      .addCase(dismissAppAndOverlayError, (state) => {
        state.error = null;
      })
      // The search micro-app dispatches these as raw string action types
      // (no exported action creator), so they are matched by literal type.
      .addCase('APP(search)/HIDE_CONTAINER', (state) => {
        state.isTemporarilyHidden = true;
      })
      .addCase('APP(search)/SHOW_CONTAINER', (state) => {
        state.isTemporarilyHidden = false;
      });
  },
});

export const currentOverlayReducer = currentOverlaySlice.reducer;
